import { useAuth } from "@clerk/react";
import { HandshakeIcon } from "lucide-react";
import { Spinner } from "@/components/ui/spinner";
import { Frame, FrameHeader, FrameTitle } from "@/components/ui/frame";
import {
  SwitchCard,
  SwitchCardContent,
  SwitchCardDescription,
  SwitchCardLabel,
  SwitchCardSwitch,
} from "@/components/ui/switch-card";
import { useCampaignStore } from "@/stores";
import { useEveActionsStore } from "@/stores/eve/eveActionsStore";

/**
 * Settings → Messaging on Amy campaigns: the Offers switch
 * (campaigns.eve_offer_review, amy set-offer-review route). While on, Amy
 * replies on no tier the team has not set for that creator — she files a
 * "Set Offer" task and waits; off releases every open task.
 */
export function OfferReviewFrame() {
  const { getToken, orgId } = useAuth();
  const { campaign, campaignId } = useCampaignStore();
  const { setOfferReview, isSavingConfig } = useEveActionsStore();
  const on = campaign?.eve_offer_review === true;

  const handleChange = async (value: boolean) => {
    const token = await getToken();
    if (!token || !campaignId || !orgId) return console.error("No token found");
    await setOfferReview(campaignId, value, orgId, token);
  };

  return (
    <Frame>
      <FrameHeader>
        <FrameTitle>Offers</FrameTitle>
      </FrameHeader>
      <SwitchCard disabled={isSavingConfig}>
        <SwitchCardSwitch id="eve_offer_review" checked={on} onCheckedChange={handleChange} />
        <SwitchCardContent>
          <SwitchCardLabel htmlFor="eve_offer_review">
            {isSavingConfig ? <Spinner /> : <HandshakeIcon />}
            Set each creator's offer before Amy quotes it
          </SwitchCardLabel>
          <SwitchCardDescription>
            Before Amy makes a creator an offer on a tier, she adds a Set Offer task and waits for you.
          </SwitchCardDescription>
        </SwitchCardContent>
      </SwitchCard>
    </Frame>
  );
}
